var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Alert',{attrs:{"type":"success","show-icon":""}},[_vm._v(" "+_vm._s(_vm.$('signup.checkAllEmail'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }